import { useState } from 'react';
import { fetcher } from './core';

function useMutation(mutation) {
  const [loading, setLoading] = useState(false);

  const mutateData = async (query = mutation, variables) => {
    setLoading(true);
    try {
      const body = { query, variables };
      const res = await fetcher(body, {});
      setLoading(false);
      return res;
    } catch (err) {
      setLoading(false);
      return err;
    }
  };

  return { loading, mutate: mutateData };
}

export default useMutation;
